import { format, startOfWeek, endOfWeek, eachDayOfInterval, addDays, parseISO, isSameDay } from 'date-fns';

function filterDataByDate(objects, targetDate) {
    const parsedTargetDate = parseISO(targetDate);

    return objects.filter((obj) => {
        const createdAtDate = parseISO(obj.taskDate);
        return isSameDay(createdAtDate, parsedTargetDate);
    });
}

function generateWeekData() {
    const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const startOfCurrentWeek = startOfWeek(new Date(), { weekStartsOn: 0 });

    return Array.from({ length: 7 }).map((_, i) => {
        const dayDate = addDays(startOfCurrentWeek, i);
        return {
            day: daysOfWeek[dayDate.getDay()],
            date: format(dayDate, 'dd MMM')
        };
    });
}

function generateWeekDataLong() {
    const startOfCurrentWeek = startOfWeek(new Date(), { weekStartsOn: 0 });

    return Array.from({ length: 7 }).map((_, i) => {
        const dayDate = addDays(startOfCurrentWeek, i);
        return {
            day: format(dayDate, 'EEEE'),
            date: format(dayDate, 'dd MMM'),
            fullDate: format(dayDate, 'yyyy-MM-dd') // For filtering in Day View
        };
    });
}

function getWeekDates(currentDate) {
    const start = startOfWeek(currentDate, { weekStartsOn: 0 }); // Set weekStartsOn to 0 for Sunday
    const end = endOfWeek(currentDate, { weekStartsOn: 0 });
    const weekDates = eachDayOfInterval({ start, end }).map((date) => format(date, 'yyyy-MM-dd'));
    return weekDates;
}

function formatTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    // Padding with zero if necessary
    const paddedHours = String(hours).padStart(2, '0');
    const paddedMinutes = String(minutes).padStart(2, '0');
    const paddedSeconds = String(remainingSeconds).padStart(2, '0');

    return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
}

function formatHoursSeconds(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);

    // Padding with zero if necessary
    const paddedHours = String(hours).padStart(2, '0');
    const paddedMinutes = String(minutes).padStart(2, '0');

    return `${paddedHours}:${paddedMinutes}`;
}

function formatHours(seconds) {
    const hours = Math.floor(seconds / 3600);
    if (hours < 1) {
        const minutes = Math.floor((seconds % 3600) / 60);
        if (minutes < 1) {
            const remainingSeconds = seconds % 60;
            if (remainingSeconds > 0) {
                return `${remainingSeconds} secs`;
            }
        } else {
            return `${minutes} mins`;
        }
    }
    return `${hours} hrs`;
}

function formatTimeHHMM(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);

    // Padding with zero if necessary
    const paddedHours = String(hours).padStart(2, '0');
    const paddedMinutes = String(minutes).padStart(2, '0');

    return `${paddedHours}:${paddedMinutes}`;
}

export { formatTime, formatTimeHHMM, filterDataByDate, generateWeekData, generateWeekDataLong, getWeekDates, formatHoursSeconds, formatHours };
